import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'

import { getThreadRatings, rateRun } from './squadApi'
import { isTempId } from './useSquadConversations'

const RATINGS_STALE_TIME_MS = 30_000

export const useTurnFeedback = (
  appToken: string,
  threadId?: string,
  runId?: string
) => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { message } = App.useApp()

  const ratingsKey = ['squad-thread-ratings', threadId ?? '']
  const ratings = useQuery({
    queryKey: ratingsKey,
    queryFn: () => getThreadRatings(appToken, threadId ?? ''),
    enabled:
      Boolean(appToken) && Boolean(threadId) && !isTempId(threadId ?? null),
    staleTime: RATINGS_STALE_TIME_MS
  })

  const rate = useMutation({
    mutationFn: (up: boolean) => rateRun(appToken, runId ?? '', up),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ratingsKey }),
    onError: () => message.error(t('workspaceHome.feedback.failed'))
  })

  const enabled = ratings.data?.enabled !== false
  const rating = runId ? (ratings.data?.ratings?.[runId]?.up ?? null) : null
  const pending = rate.isPending

  const setRating = (up: boolean) => {
    if (runId && rating !== up) rate.mutate(up)
  }

  return { enabled, rating, pending, setRating }
}
